import { Info } from 'lucide-react';

import { toast } from 'sonner';

import { HStack } from '@shared/ui/Stack';

import cls from './showToast.module.scss';

export const showToast = (name: string) => {
  toast(
    <HStack gap={'8'}>
      <Info size={16} />
      <div>{name}</div>
    </HStack>,
    {
      classNames: {
        toast: cls.toast
      },
      position: 'bottom-center',
      duration: 2000
    }
  );
};
